import VoyageArrivalWindowData from "../data";

export default function voyageArrivalWindowDataFromJson(json) {
    return new VoyageArrivalWindowData(
        json.id,
        json.earliest_eta,
        json.latest_eta,
        json.enforce
    )
}